import { TResultType } from 'legacy/lut/classes/models/partner360/ELT/financialData/kpi/IKpi'

import { Translation } from 'cng-common/features/translations'
import { Flex } from 'core-components/library/flex'

import styles from './KpiTableContent.module.scss'

interface IKpiTableContentProps {
  result: TResultType
  align: 'start' | 'center'
}

export const KpiTableContent = ({ result, align }: IKpiTableContentProps) => {
  if (result.type === 'status') {
    return (
      <div className={styles.root} style={{ justifyContent: align }}>
        <div className={styles.statusContainer}>
          <span className={styles.statusCircle} style={{ backgroundColor: result.color }} />
          <Translation span text={result.value} />
        </div>
      </div>
    )
  }

  if (result.type === 'text') {
    return (
      <div className={styles.root} style={{ justifyContent: align }}>
        {result.name && (
          <div className={styles.textName}>
            <Translation span text={result.name} />
          </div>
        )}
        <span style={{ color: result.color || 'black' }}>&nbsp;{result.value}</span>
      </div>
    )
  }

  if (result.type === 'textWithAsterisk') {
    return (
      <div className={styles.root} style={{ justifyContent: align }}>
        {result.name ? (
          <Flex gap={'none'} className={styles.textWithAsteriskWrapper}>
            <div className={styles.textName}>
              <Translation span text={result.name} />
            </div>
            <div className={styles.textWithAsteriskWrapper__asterisk}>*</div>
          </Flex>
        ) : null}
        <span style={{ color: result.color || 'black' }}>&nbsp;{result.value}</span>
      </div>
    )
  }

  return null
}
